class TabsComponents extends HTMLElement {
  constructor() {
    super();
    this.navItems = [];
    this.contents = [];
  }

  connectedCallback() {
    this.navItems = this.querySelectorAll('.tab-nav-item');
    this.contents = this.querySelectorAll('[data-tab]');

    if (!this.navItems.length || !this.contents.length) return;

    this.navItems.forEach(item => {
      item.addEventListener('click', () => {
        this.activateTab(item.dataset.tab);
      });
    });

    // Activate first tab by default
    this.activateTab(this.navItems[0].dataset.tab);
  }

  activateTab(tabId) {
    // Remove active from all nav items
    this.navItems.forEach(item =>
      item.classList.remove('active')
    );

    // Remove active from all contents
    this.contents.forEach(content =>
      content.classList.remove('active')
    );

    // Activate current nav
    const activeNav = this.querySelector(
      `.tab-nav-item[data-tab="${tabId}"]`
    );
    if (activeNav) activeNav.classList.add('active');

    // Activate matching content
    const activeContent = this.querySelector(
      `[data-tab="${tabId}"]:not(.tab-nav-item)`
    );
    if (activeContent) activeContent.classList.add('active');
  }
}

customElements.define('tabs-components', TabsComponents);
